import { useQuery } from "@tanstack/react-query";
import { getHomeVariant } from "@/api/site";
import { Seo } from "@/components/Seo";
import HomeReglette from "./home/HomeReglette";
import HomePalmares from "./home/HomePalmares";
import HomeROI from "./home/HomeROI";

/**
 * Landing page publique. Aiguilleur de modèle : la variante active est choisie
 * dans le panneau admin (GET /home-variant). Par défaut « réglette » (modèle 1).
 * La mention "sans valeur légale" est rendue par le DisclaimerBanner du Layout.
 *
 * V5 — SEO : titre Google court "Simulation DPE : optimisez vos travaux"
 * (rawTitle pour ne pas suffixer "— Mon Diag Énergétique" sur la home).
 */
export default function LandingPage() {
  const { data } = useQuery({
    queryKey: ["home-variant"],
    queryFn: getHomeVariant,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (data?.variant === "palmares") return <HomePalmares />;
  if (data?.variant === "roi") return <HomeROI />;
  return (
    <>
      <Seo
        title="Simulation DPE : optimisez vos travaux"
        rawTitle
      />
      <HomeReglette />
    </>
  );
}